import * as Sentry from "@sentry/react";

if (window.App.env !== 'local') {
    Sentry.init({
        dsn: "https://70917ba29de7d47df61f770f8e5670eb@o4507378303696896.ingest.us.sentry.io/4507662486667264",
        environment: window.App.env, // Explicitly set to 'production'
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: 0.1,
        tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}
